import { makePrivateApiCall } from "utilities/dist/api";
import {
    INVOICE_RECOMMENDATION_DATA,
    INVOICE_RECOMMENDATION_ERROR,
    INVOICE_RECOMMENDATION_LOADING,
    INVOICE_RECOMMENDATION_TOGGLE,
} from "../constants";
import { authExpire } from "../../auth/actions";

export const toggleRecommendationModal = () => dispatch =>
    dispatch({
        type: INVOICE_RECOMMENDATION_TOGGLE,
    });

export const loadInvoiceRecommendation = () => async (dispatch, getState) => {
    const { invoiceBuilder } = getState();
    if (!invoiceBuilder.customer?.id) return null;
    dispatch({
        type: INVOICE_RECOMMENDATION_LOADING,
        payload: true,
    });

    return makePrivateApiCall({
        url: `/product/recommendation?customerId=${invoiceBuilder.customer.id}`,
        method: "get",
    })
        .then(res => {
            return dispatch({
                type: INVOICE_RECOMMENDATION_DATA,
                payload: res.data,
            });
        })
        .catch(err => {
            if (err.response && err.response.status === 401) {
                return dispatch(authExpire());
            }

            dispatch({
                type: INVOICE_RECOMMENDATION_ERROR,
                payload: err?.response?.data?.message || err.message,
            });
        });
};
